import React, { useState, useEffect } from "react";
import { FiWifiOff, FiWifi } from "react-icons/fi";
import "./OfflineNotifier.css";

export default function OfflineNotifier() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [statusType, setStatusType] = useState("offline"); // "offline" | "online"

  useEffect(() => {
    const handleOffline = () => {
      setIsOffline(true);
      setStatusType("offline");
      setToastMessage("You are currently working offline.");
      setShowToast(true);
    };

    const handleOnline = () => {
      setIsOffline(false);
      setStatusType("online");
      setToastMessage("Internet connection restored!");
      setShowToast(true);

      const timer = setTimeout(() => {
        setShowToast(false);
      }, 4000);
      return () => clearTimeout(timer);
    };

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    if (!navigator.onLine) {
      handleOffline();
    }

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  if (!showToast && !isOffline) return null;

  return (
    <div className={`offline-toast ${statusType} ${showToast || isOffline ? "show" : ""}`} role="status">
      {statusType === "offline" ? (
        <FiWifiOff className="toast-icon" />
      ) : (
        <FiWifi className="toast-icon" />
      )}
      <span className="toast-text">{toastMessage || "You are currently offline."}</span>
    </div>
  );
}
